import { render, staticRenderFns } from "./account-verify-personal-details.vue?vue&type=template&id=77406c16&"
import script from "./account-verify-personal-details.vue?vue&type=script&lang=js&"
export * from "./account-verify-personal-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports